import React from "react";
import { Grid } from "@mui/material";
import cssStyles from "./cms_renderer.module.scss";
import { prepareCardsForCategoriesGrid } from '@/translator';
import CustCarousel  from "./CustCarousel";
import GenerateCategoryCard from "@/components/products/category_cards";
import type { SectionData, ComponentRenderProps } from "./index";
import { getBrandPathEntry } from "./getCms";
import { handleProductSelection } from "./shared";

interface CategoriesCarouselProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const CategoriesCarousel = ({ sectionData, props }: CategoriesCarouselProps): JSX.Element | null => {
    console.log("CategoriesCarousel - sectionData:", sectionData);
    const { vendorName } = props;
    const items = GenerateCategoryCard(
        prepareCardsForCategoriesGrid(sectionData.items as any[], getBrandPathEntry(vendorName as string), vendorName as string),
        handleProductSelection,
        (sectionData.uiCompType?.options?.height || "320"),
        (sectionData.uiCompType?.options?.width || "320"),
        sectionData.trackId || "CategoryCarouselCards",
    );
    return <CustCarousel sectionData={{ ...sectionData, items }} props={props} />;
}
export default CategoriesCarousel;
